<template>
    <div>
        <!--    <img src="./print.svg" alt="" style="width: 100%;">-->
        <div class="printBanner printBox">
            <div class="backImage">
                <img :src="bannerImgs" alt="" class="backBannerimgs"/>
                <div class="container mpStep" style="width: 970px">
                    <div class="mpStep_box">
                        <div class="mpStep_mess">
                            <div class="mpStep_boxicon">
                                <i class="iconfont icon-gengduo" style="font-size: 44px"></i>
                            </div>
                            <p>选择打印工艺材料</p>
                        </div>

                        <img src="../../assets/arrow.png" alt=""/>
                        <div class="mpStep_mess">
                            <div class="mpStep_boxicon">
                                <i class="el-icon-upload"></i>
                            </div>
                            <p>上传3D打印模型</p>
                        </div>

                        <img src="../../assets/arrow.png" alt=""/>
                        <div class="mpStep_mess">
                            <div class="mpStep_boxicon">
                                <i class="el-icon-s-check"></i>
                            </div>
                            <p>选择打印服务商</p>
                        </div>

                        <img src="../../assets/arrow.png" alt=""/>
                        <div class="mpStep_mess">
                            <div class="mpStep_boxicon">
                                <i class="el-icon-edit"></i>
                            </div>
                            <p>开始打印</p>
                        </div>
                    </div>
                    <div
                        style="
              text-align: center;
              background: #ffffff;
              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
              border-radius: 1px;
              height: 130px;
              margin-top: 30px;
              padding: 20px 30px;
            "
                   ref="selectTop"
					>
                        <div
                            style="
                display: flex;
                justify-content: center;
                align-items: center;
                border-bottom: 1px solid #e3e3e3;
                padding-bottom: 30px;
              "
                        >
                            <div style="margin-right: 20px">
                                <el-select v-model="technologyUuid" placeholder="选择工艺" @change="materialsChange">
                                    <el-option
                                        v-for="item in options"
                                        :key="item.uuid"
                                        :label="item.name"
                                        :value="item.uuid">
                                    </el-option>
                                </el-select>
                                <el-cascader
                                    ref="materialsRef"
                                    v-model="materialUuid"
                                    :props="props"
                                    :options="options2"
                                    placeholder="请选择材料"  @change="materialsChange"></el-cascader>
                                <el-select v-model="isHollow" placeholder="填充"  @change="materialsChange">
                                    <el-option
                                        v-for="item in options3"
                                        :key="item.value"
                                        :value="item.value"
                                        :label="item.label">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="mpBtn">
                                <el-upload
                                    action="/service-center/upload/file/single"
                                    :on-success="handleAvatarSuccess"
                                    class="hiddenInput"
                                    :headers="headers"
                                    :before-upload="beforeAvatarUpload"
                                    :disabled="!technologyUuid || !technologyUuid || !isHollow || !isLogin || isAnonymous"
                                    :show-file-list="false">
                                    <el-button type="primary" icon="el-icon-upload" @click="toPlaceAnOrder">上传3D打印模型</el-button>
                                </el-upload>
                                <el-button type="primary" @click="toServiceAuthentication"  style="position: relative;right: -22px;">
                                    服务商入驻
                                </el-button>
                            </div>
                        </div>
                        <div style="margin-top: 30px;position: relative;">
                            <p>
                                没有模型？去<a href="javascript:void(0);" @click="toDesignRelease">发布设计需求</a> |
                                <a href="javascript:void(0);" @click="to3DModel">模型库</a>
                            </p>
                            <el-button icon="el-icon-time" style="position: absolute;right: 0;top: -15px;"  @click="historyUploadSelect">历史上传
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="background: #f1f5fe">
            <div class="container">
                <section style="padding-top: 30px; padding-bottom: 30px">
                    <div style="background-color: #fff;margin-bottom: 15px;padding-bottom: 10px;">
                        <el-row :gutter="5"
                            class="materArt"
                            style="padding-bottom: 15px; margin-bottom: 10px">
                            <el-col :span="1" class="materiaTitle">工艺：</el-col>
                            <el-col :span="21">
                                <el-row :gutter="5">
                                    <el-col :span="2"
                                        v-for="(items, index) in marterialList"
                                        :key="index"
                                        :class="materialiArt == index ? 'materArtallP' : 'materArtallP1' "
                                        @click.native="getMaterialArt(index,items.uuid)"
                                        style="width: auto">
                                        <el-tooltip v-if="items.name != '全部'" class="item" effect="dark" :content="contentText" placement="bottom-start">
                                            <span style="padding: 3px 15px" @mouseenter="tooltip(items.name)">{{ items.name }}</span>
                                        </el-tooltip>
                                        <span v-else style="padding: 3px 15px">{{ items.name }}</span>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row :gutter="5" class="materArtall">
                            <el-col :span="1" class="materiaTitle">材料：</el-col>
                            <el-col :span="21">
                                <el-row :gutter="5">
                                    <el-col :span="2"
                                        v-for="(items, index) in artList"
                                        :key="index"
                                        @click.native="getMaterialDetail(index,items.uuid)"
                                        :class="materialIndex == index ? 'materArtallP' : 'materArtallP1'"
                                        style="width: auto">
                                        <span style="padding: 3px 15px">{{ items.material }}</span>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row :gutter="5" class="materDetails" v-if="classShow">
                            <el-col :span="1" class="">&nbsp;</el-col>
                            <el-col
                                :span="22"
                                style="background-color: #f1f5fe; padding: 15px 15px 0"
                            >
                                <el-row :gutter="5">
                                    <el-col
                                        :span="6"
                                        style="margin-bottom: 15px; cursor: pointer"
                                        v-for="(itemsTwo, indexs) in artList[materialIndex].materTwo"
                                        :key="indexs"
                                        :class="materialitems == indexs ? 'materDetailsT' : ''"
                                        @click.native="handMaterialItems(indexs,itemsTwo.uuid)"
                                    >
                                        <span>{{ itemsTwo.name }}</span>
                                    </el-col>
                                </el-row>
                            </el-col>

                        </el-row>
                    </div>

                    <el-row  v-loading="loading" :gutter="30">
                        <el-col :span="6" v-for="(items, index) in printList" :key="index">
                            <el-card class="box-card" shadow="hover">
                                <h4 class="mpTitle">{{ items.materialName }}</h4>
                                <p class="mpPrice">¥{{ items.unitPrice }}元/克</p>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="选择该材料"
                                    placement="top-start">
                                    <el-checkbox v-model="items.checked" class="mpCheck" v-if="items.userUuid===enterPriseUuid" disabled></el-checkbox>
                                    <el-checkbox v-model="items.checked" class="mpCheck" v-else @change="chooseMaterial(items,index)"></el-checkbox>
                                </el-tooltip>
                                <div class="mpBox">
                                    <el-image
                                        style="width: 100px; height: 70px; margin-right: 10px;margin-top: 12px;"
                                        :src="items.thumbUrl"
                                        fit="fill"
                                    >
                                    </el-image>
                                    <div class="mpInfo">
                                        <dl class="mpDetail clearfix">
                                            <dt>工作温度：</dt>
                                            <dd :title="`${items.operationTemperature}℃`" style="width: 60px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{ items.operationTemperature }}℃</dd>
                                            <dt>尺寸精度：</dt>
                                            <dd>{{ items.sizePrecision }}㎜</dd>
                                            <dt>发货周期：</dt>
                                            <dd>{{ items.sendCycleMin }}-{{ items.sendCycleMax }}天</dd>
                                        </dl>
                                    </div>
                                </div>
                                <div class="tagsbox">
                                    <el-tag size="mini" type="danger">
                                        {{ items.technologyName }}
                                    </el-tag>
                                </div>
                                <div>
                                    <dl class="mpDetail">
                                        <dt>表面质感：</dt>
                                        <dd style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                                            {{ items.surfaceTexture }}
                                        </dd>
                                        <dt>材料特点：</dt>
                                        <dd :title="items.characteristic"
                                            style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;min-height:64px">
                                            {{ items.characteristic }}
                                        </dd>
                                        <dt>打印设备：</dt>
                                        <el-tooltip class="item" effect="dark" :content="items.printMachine" placement="bottom-end">
                                            <dd :title="items.printMachine"
                                                style="display: -webkit-box;
                                                -webkit-box-orient: vertical;
                                                -webkit-line-clamp: 1;
                                                overflow: hidden;">
                                                {{ items.printMachine }}
                                            </dd>
                                        </el-tooltip>

                                        <dt>交易量：</dt>
                                        <dd :title="items.totalNum"
                                            @click="handleEnterMess(items.enterPriseName,items,7)"
                                            style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;
                                            overflow: hidden;;min-height:44px;cursor:pointer">
                                            {{ items.totalNum }}
                                        </dd>
                                    </dl>
                                    <br style="float: none"/>
                                    <div :title="items.storeName"
                                        class="mpFooter-v1"
                                        @click="handleEnterMess(items.enterPriseName,items,1)"
                                        style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;overflow: hidden;cursor:pointer">
                                        <p style="width: 90%;margin: 0 auto;">{{ items.storeName }}</p>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
						<div style="text-align: center;" v-if="printList.length === 0">
							<img src="../../assets/暂无内容.jpg" style="width: 200px;" >
						</div>
                    </el-row>
                    <div style="text-align: right" v-if="printList.length >0">
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="printCurrent"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </section>
            </div>
        </div>
        <div style="background: #f1f5fe">
            <div class="container">
                <section style="padding-bottom: 0px; margin-top: -60px">
                    <div class="printTitle">
                        热门服务<span class="more" @click="hotServeMore"> 查看更多 > </span>
                    </div>
                    <el-row :gutter="30">
                        <el-col
                            :span="6"
                            v-for="(items, index) in hotServeList"
                            :key="index"
                            @click.native="getServiceDetails(items.uuid)"
                        >
                            <el-card
                                class="box-card"
                                shadow="hover"
                                :body-style="{ padding: '0px' }"
                            >
                                <div class="image" v-if="items.urlList.length > 0">
                                    <img :src="items.urlList[0].urlPath" alt=""/>
                                </div>
                                <div style="padding: 15px">
                                    <div class="titname">
                                         <h4 class="mpTitle">{{ items.serviceName }}</h4>
                                    </div>

                                    <p class="mpComp" :title="items.enterPriseName">
                                        {{ items.enterPriseName }}
                                    </p>
                                    <dl class="mpDetail clearfix">
                                        <dt>服务行业：</dt>
                                        <dd>{{items.serviceTradeName| ellipsisService}}</dd>
                                    </dl>
                                    <p class="mpPrice">¥{{ items.servicePrice }} <span>议价</span></p>
                                    <div class="mpFooter">
                                        <span>
                                            <i class="el-icon-view" style="margin-right: 8px"></i>
                                            浏览量：{{ items.pageViews }}
                                        </span>
                                        <span>
                                            <i class="el-icon-star-off" style="margin-right: 8px"></i>
                                            收藏量：{{ items.collectionVolume }}
                                        </span>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </section>
            </div>
        </div>
        <div class="container">
            <section style="margin-bottom: 60px; margin-top: -30px">
                <div class="printTitle">
                    推荐服务商<span class="more" @click="getServiceList">
            查看更多 >
          </span>
                </div>
                <el-row :gutter="30">
                    <el-col
                        :span="4"
                        style="margin-bottom: 30px; cursor: pointer"
                        v-for="(items, index) in serviceProvider"
                        :key="index"
                        @click.native="getPrintServiceIndex(items.enterPriseId)"
                        class="img_div"
                    >
                        <img
                            :src="items.storeLogo"
                            v-if="items.storeLogo!=''"
                            alt=""
                            style="width: 100%; height: 80px"
                            class="imageEl"
                        />
                        <img
                            src="../../assets/storeLogo.jpeg"
                            v-else
                            alt=""
                            style="width: 100%; height: 80px"
                            class="imageEl"
                        />
                        <div class="mask">
                            <div class="maskContent">
                                <p style="font-size: 14px; ">{{ items.enterPriseName }}</p>
                                <p
                                    style="
                                        font-size: 14px;
                                        color: #fff;
                                        display: flex;
                                        padding: 5px 14px 0"
                                >
                                    <span>好评度：</span>
                                    <el-rate
                                        v-model="items.star"
                                        disabled
                                        :colors="colors"
                                    ></el-rate>
                                </p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </section>
        </div>
        <!--历史上传-->
        <history-upload ref="historyUploadRef" @historyToPrint="historyToPrint"></history-upload>
    </div>
</template>

<script>
    import {getBannerList,getCredentials,designerByUserId,
        getNewcurrent, getDictionaryItem, getMaterialList,
        getServiceabilityList, getShopperList,findTypeListByGroupUuid,
        getDictionaryGroup } from "../../utils/interface";
    import {mapState, mapMutations} from "vuex";
    import historyUpload from './historyUpload'
    export default {
        //   我要打印
        name: "print",
        metaInfo: {
            title: '3D打印服务交易平台——物品定制3D打印|增材云我要打印', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '3D打印|3D打印服务|3D打印厂商|3D打印原料|金属3D打印|陶瓷|光敏树脂|砂型3D打印|毕设3D打印|3D打印定制\n'
            },{                 // set meta
                name: 'description',
                content: '3D打印厂商免费入驻接单，超多厂商，用户任选，3D打印进度实时更新，第三方监管服务有保障。增材云，聚合3D打印设计师、3D打印厂商、3D打印原料、3D打印模型、3D打印软件及课程等6大资源。'
            }],
        },
        components: {historyUpload},
        data() {
            return {
                identity: '',
                groupCode: "print_banner",
                technologyCode:'technology_print',
                parentCode: 'material_print',
                bannerImgs: require("../../assets/我要打印/我要打印-banner.jpg"),
                marterialList:[],
                // 工艺选择
                artList: [],
                artScreen: [
                    {
                        name: "最新",
                    },
                    {
                        name: "最热",
                    },
                    {
                        name: "收藏",
                    },
                    {
                        name: "点赞",
                    },
                    {
                        name: "下载",
                    },
                ],
                checked: "",
                options: [],
                options2: [],
                options3: [
                    {
                        value: "YES",
                        label: "空心",
                    },
                    {
                        value: "NO",
                        label: "实心",
                    }
                ],
                props: {
                    value: 'uuid',
                    label: 'name'
                },
                technologyUuid: "",
                materialUuid: "",
                isHollow: "",
                isAnonymous:false,
                isReprocess:"",
                materialManagerUuid:"",
                // 推荐材料
                printList: [],
                // 热门服务
                hotServeList: [],
                // 推荐服务商
                serviceProvider: [],
                materialIndex: "0",
                materialitems: "0",
                materialiArt: "0",
                screenIndex: "0",
                screenIndex2: "0",
                classShow: false,
                setIn: null,
                colors: ["#da251d", "#da251d", "#da251d"],
                technologyType:'',
                firstMaterialClassify:'',
                secondMaterialClassify:'',
                printCurrent:1,
                total: 0,
                pageSize: 4,
                enterPriseUuid:"",
                headers: {
                    'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
                },
                userMessages: {},
                loading: true,
                contentText: '',
            };
        },
        created() {
            getNewcurrent().then((res) => {
                this.userMessages = res;
                this.enterPriseUuid = res.uuid;
                if(res.identity == 'ENTERPRISE' || res.identity == 'STAFF'){
                    this.designer = false;
                }else{
                    this.designer = true;
                }
            })
            .catch((err) => {
                console.log(err);
            });
            this.setIn = setInterval(() => {
                if (this.isTokenDoor === true) {
                    clearInterval(this.setIn);
                    this.getItemList();
                    this.getBannerList();
                    // 查询材料管理列表
                    this.getMaterialManagerList();
                    // 查询热门服务列表
                    this.getServiceabilityList();
                    // 查询推荐服务商
                    this.getShopperList();
                    // 查询工艺数据字典
                    this.getDictionaryGroup();
                    this.getMaterialDictionaryList()
                }
            }, 500);
        },
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
                isLogin: "isLogin",
            }),
        },
        mounted() {
            this.isServiceAuthentication();
        },
        filters: {
            ellipsisService(value) {
                if (!value) return '';
                if (value.length > 10) {
                    return value.slice(0, 10) + '...'
                }
                return value;
            }
        },
        methods: {
            ...mapMutations(["isLoginVuex","isuserServeVuex"]),
            tooltip(name){
                switch(name){
                    case "FDM":
                        this.contentText = '熔融沉积成型法'
                        break
                    case "SLS":
                        this.contentText = '粉末材料选择性烧结'
                        break
                    case "SLA":
                        this.contentText = '立体光固化成型法'
                        break
                    case "SLM":
                        this.contentText = '选择性激光熔化技术'
                        break
                    case "3DP":
                        this.contentText = '立体喷墨打印法'
                        break
                    case "DLP":
                        this.contentText = '数字光处理成型技术'
                        break
                    case "LCD":
                        this.contentText = '选择性区域透光技术'
                        break
                    case "EBM":
                        this.contentText = '电子束熔融3D打印技术'
                        break
                    case "CJP":
                        this.contentText = '全彩色喷射打印成型技术'
                        break
                    default:
                        this.contentText = name
                        break
                }
            },
            // 跳转企业详情
            handleEnterMess(name,uuid,index){
                let mess = this.serviceProvider.find(items=>{
                    return items.enterPriseName == name
                });
                let routeData = this.$router.push({
                    name: "printServiceIndex",
                    params: {enterPriseId: uuid.enterPriseId},
                });
                window.open(routeData.href, "_self");
                /*let detailsUrl = '/' + uuid.enterPriseId;
                this.$router.push('/printServiceIndex' + detailsUrl + "/" + index)*/
            },
            // 工艺数据字典
            getDictionaryGroup(){
                let params = {
                    parentCode:this.parentCode,
                };
                getDictionaryGroup(params).then((res) => {
                    if(res.length > 0){
                        let allData = new Array();
                        let array = new Array();
                        for(let i=0;i<res.length;i++){
                            let arr = {};
                            arr.uuid = res[i].uuid;
                            arr.name = res[i].code;
                            arr.material = res[i].name;
                            // 查询子数据
                            let singleData = new Array();
                            findTypeListByGroupUuid({groupUuid: res[i].uuid}).then((result) => {
                                if(result&&result.data.length > 0){
                                    for(let k=0;k<result.data.length;k++){
                                        let data = {};
                                        data.name = result.data[k].name;
                                        data.uuid = result.data[k].uuid;
                                        singleData.push(data);
                                        allData.push(data);
                                    }
                                }
                            });
                            arr.materTwo = singleData
                            arr.materTwo.unshift({uuid:'',name:'全部'})
                            array.push(arr);
                        }
                        array.unshift({uuid:'',name:'全部',material:'全部',materTwo:allData});
                        this.artList = array
                    }
                });
            },
            // 获取材料一二级分类
            getMaterialDictionaryList(){
                getDictionaryGroup({parentCode:'material_print'}).then((res)=>{
                    res.map((item)=>{
                        findTypeListByGroupUuid({groupUuid:item.uuid}).then((res)=>{
                            if(res){
                                item.children = res.data;
                            }
                        })
                    });
                    this.options2 = res
                })
            },
            // 服务商首页
            getPrintServiceIndex(enterPriseId) {
                let routeData = this.$router.resolve({
                    name: "printServiceIndex",
                    params: { enterPriseId:enterPriseId },
                });
                window.open(routeData.href, "_blank");
            },
            // 判断当前用户是否可以进行服务商认证
            isServiceAuthentication() {
                // if(this.isLogin){
                    getNewcurrent().then((data) => {
                        // 1、设计师不显示
                        // 2、个人用户要进行企业认证
                        this.identity = data.identity;
                        if(this.identity === 'ANONYMOUS'){
                            this.isAnonymous = true;
                        }
                    })
                // }
            },
            // 服务商认证
            toServiceAuthentication() {
                if(this.$store.state.isLogin) {
                    getNewcurrent().then((data) => {
                        designerByUserId(data.uuid).then((res)=>{
                            if (res != null && res !== "") {
                                this.$message({
                                    type: "error",
                                    message: "您已申请平台设计师，无法申请商家入驻！",
                                });
                                return false;
                            }else {
                                this.identity = data.identity;
                                if (this.identity === 'ENTERPRISE') {
                                    this.$router.push({
                                        name: "printServiceAuthentication",
                                    });
                                } else if (this.identity === 'PERSONAL' || this.identity === 'ANONYMOUS') {
                                    this.$confirm('请先进行企业资质认证!', '提示', {
                                        confirmButtonText: '去认证',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        window.sessionStorage.setItem("userServeId", "11");
                                        let routeData = this.$router.resolve({
                                            name: "userCenter",
                                            params: {
                                                userServeId: '11',
                                            },
                                        });
                                        window.open(routeData.href, "_target");
                                    });
                                }
                            }
                        });
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push("/login");
                    return false;
                }
            },
            // 热门服务列表页
            hotServeMore() {
                let routeData = this.$router.resolve({
                    name: "printList",
                });
                window.open(routeData.href, "_blank");
            },
            // 商家列表页
            getServiceList() {
                let routeData = this.$router.resolve({
                    name: "printHot",
                });
                window.open(routeData.href, "_blank");
            },
            // 获取分类
            getMaterialDetail(i,uuid) {
                this.firstMaterialClassify = uuid;
                this.secondMaterialClassify = '';
                this.getMaterialManagerList();
                if(i === 0){
                    this.classShow = false;
                } else {
                    if (this.materialIndex == i) {
                        this.classShow = !this.classShow;
                    } else {
                        this.classShow = true;
                    }
                }
                this.materialIndex = i;
            },
            // 点击获取材料
            handMaterialItems(i,uuid) {
                this.materialitems = i;
                this.secondMaterialClassify = uuid;
                this.getMaterialManagerList();
            },
            getMaterialArt(i,uuid) {
                this.materialiArt = i;
                this.technologyType = uuid;
                this.getMaterialManagerList();
            },
            // 分页
            handleCurrentChange(val){
                this.printCurrent = val;
                this.loading = true
                this.getMaterialManagerList()
            },
            // 材料管理
            getMaterialManagerList(){
                let params = {
                    //isExcludeUserUuid:this.enterPriseUuid,
                    technologyType:this.technologyType,
                    firstMaterialClassify:this.firstMaterialClassify,
                    secondMaterialClassify:this.secondMaterialClassify,
                    current:this.printCurrent,
                    pageSize:this.pageSize
                };
                getMaterialList(params).then((res) => {
                    this.printList = []
                    res.list.map(item=>{
                        this.printList.push({
                            'checked': false,
                            ...item
                        })
                    })
                    this.loading = false
                    this.total = res.total;
                    this.pageSize = res.size;
                    this.printCurrent = res.current;
                });
            },
            // 热门服务
            getServiceabilityList(){
                let params = {
                    current:1,
                    pageSize:4
                };
                getServiceabilityList(params).then((res) => {
                    this.hotServeList = res.list;
                });
            },
            // 推荐服务商
            getShopperList(){
                let params = {
                    examineStatus:"PASS",
                    current:1,
                    pageSize:12,
                    survival:'ENABLE',
                    isRecommend:1,
                };
                getShopperList(params).then((res) => {
                   this.serviceProvider = res.list;
                });
            },
            // 查询条件
            getItemList(){
                let params = {
                    groupCode: this.technologyCode,
                };
                getDictionaryItem(params).then((res) => {
                    console.log('1111',res );
                    this.marterialList = res;
                    // 在最前端增加一个全部
                    this.marterialList.unshift({uuid:'',name:'全部'})
                });
                getDictionaryItem(params).then((res) => {
                    this.options = res;
                });
            },
            getBannerList() {
                let params = {
                    groupCode: this.groupCode,
                };
                getBannerList(params).then((res) => {
                    if (res.length !== 0) {
                        this.bannerImgs = res[0].value;
                    }
                });
            },
            toDesignRelease(){
                console.log("isUser:" + this.userMessages);
                if(this.isLogin){
                    let data = {
                        userUuid: this.userMessages.uuid
                    };
                    if(this.userMessages.uuid && this.userMessages.identity != 'ENTERPRISE'){
                        getCredentials(data).then((res) => {
                            if(res.success){
                                if(res.data.status == 'APPROVE' && res.data.identityType == 'PERSONAL'){
                                    // this.$router.push('/designRelease')
									let routeData = this.$router.resolve({
									    name: "designRelease",
									    params: {url: "designRelease"},
									});
									window.open(routeData.href, "_blank");
                                }else if(res.data.status == 'SUBMIT' && res.data.identityType == 'PERSONAL'){
                                    this.$message({
                                        type: "success",
                                        message: "用户实名认证审核中,认证通过后再来执行当前操作！",
                                    });
                                }else if(res.data.status == 'REJECT' && res.data.identityType == 'PERSONAL'){
                                    this.$message({
                                        type: "success",
                                        message: "用户实名认证信息被拒绝，请至个人中心查看详情！",
                                    });
                                }
                            }else{
                                this.$message({
                                    type: "error",
                                    message: "用户个人实名认证信息未提交,认证通过后再来执行当前操作！",
                                });
                            }
                        })
                    }else if(this.userMessages.identity == 'ENTERPRISE' || this.userMessages.identity == 'STAFF'){
                        // this.$router.push('/designRelease')
						let routeData = this.$router.resolve({
						    name: "designRelease",
						    params: {url: "designRelease"},
						});
						window.open(routeData.href, "_blank");
                    }
                }else{
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            // 跳转到3d模型库
            to3DModel() {
                let routeData = this.$router.resolve({
                    name: "model",
                    params: {url: "model"},
                });
                window.open(routeData.href, "_blank");
            },
            getServiceDetails(uuid) {
                let routeData = this.$router.resolve({
                    name: "printServiceDetails",
                    params: { uuid: uuid },
                });
                window.open(routeData.href, "_blank");
            },
            // 选择材料回显
            chooseMaterial(val,index){
                if(val.checked){
					document.documentElement.scrollTop = this.$refs['selectTop'].offsetTop;
					this.$message.success('可以上传3D打印模型了~')
                    this.printList.map(item=>{
                        if(item.uuid === val.uuid){
                            this.technologyUuid = item.technologyType;
                            this.materialUuid = [item.firstMaterialClassify,item.secondMaterialClassify];
                            this.isHollow = item.sustainHollow;
                            this.materialManagerUuid = item.uuid;
                            this.isReprocess = item.sustainReprocess;
                            if(item.sustainHollow === 'YES'){
                                this.options3 = [
                                    {
                                        value: "YES",
                                        label: "空心",
                                    },
                                    {
                                        value: "NO",
                                        label: "实心",
                                    }
                                ]
                            } else {
                                this.options3 = [
                                    {
                                        value: "NO",
                                        label: "实心",
                                    }
                                ]
                            }
                        } else {
                            item.checked = false
                        }
                    })
                } else {
                    this.technologyUuid = '';
                    this.materialUuid = [];
                    this.isHollow = '';
                    this.materialManagerUuid = '';
                    this.isReprocess = "";
                    this.options3 = [
                        {
                            value: "YES",
                            label: "空心",
                        },
                        {
                            value: "NO",
                            label: "实心",
                        }
                    ]
                }
            },
            // banner部分修改材料信息后材料列表取消选中状态
            materialsChange(){
                // 选择之后清空选择材料的id,防止查询服务商信息
                this.materialManagerUuid = "";
                this.isReprocess = "";
                this.printList.map(item=>{
                    item.checked = false;
                    this.options3 = [
                        {
                            value: "YES",
                            label: "空心",
                        },
                        {
                            value: "NO",
                            label: "实心",
                        }
                    ]
                });
            },
            // 跳转至打印下单页
            toPlaceAnOrder() {
                if (this.isLogin) {
                    if( !this.technologyUuid || !this.materialUuid || !this.isHollow){
                        this.$message.warning('请先选择工艺/材料/填充，再上传3D打印模型哦~')
                    }else if(this.isAnonymous){
                        this.$confirm('请先进行实名认证!', '提示', {
                            confirmButtonText: '去认证',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push('/userCenter/10');
                            /*window.sessionStorage.setItem("userServeId", "10");
                            let routeData = this.$router.resolve({
                                name: "userCenter",
                            });
                            window.open(routeData.href, "_target");*/
                        });
                    }
                }else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            // 模型文件上传
            handleAvatarSuccess(res, file) {
                this.$message.success('上传成功！');
                let query = {
                    fileName: res.name,
                    fileUrl: res.url,
                    technologyValue: this.technologyUuid,
                    materialValue: this.materialUuid,
                    isHollow: this.isHollow,
                    materialManagerUuid: this.materialManagerUuid,
                    isReprocess: this.isReprocess
                };
                let routeData = this.$router.push({
                    name: "printPlaceAnOrder",
                    query: query
                });
                //window.open(routeData.href, "_blank");
            },
            beforeAvatarUpload(file) {
                let fileType = 'obj,OBJ,stl,STL';
                let fileName = file.name.lastIndexOf('.') + 1;
                const fileNameLen = file.name.length;
                const fileTypeName = file.name.substring(fileName, fileNameLen);
                if(fileType.indexOf(fileTypeName) === -1){
                    this.$message.warning('请上传obj、stl格式模型文件');
                    return false
                } else {
                    return true
                }
            },
            // 点击历史上传
            historyUploadSelect(){
				let newToken = this.$cookies.get("api_token_new");
				if (newToken) {
				this.$refs.historyUploadRef.init('index',this.technologyUuid,this.materialUuid,this.isHollow)
				} else {
				    this.$router.push("/login");
				}
            },
            // 历史上传打印
            historyToPrint(val){
                let query = {
                    fileName: val.name,
                    fileUrl: val.url,
                    technologyValue: this.technologyUuid,
                    materialValue: this.materialUuid,
                    isHollow: this.isHollow,
                    materialManagerUuid: this.materialManagerUuid,
                    isReprocess: this.isReprocess,
                };
                this.$router.push({
                    name: "printPlaceAnOrder",
                    query: query
                });
                //window.open(routeData.href, "_blank");
            }
        },

    };
</script>

<style scoped lang="less">
    .container {
        width: 1200px;
        margin: 0 auto;
    }
    .mpBtn{
        display: flex;
    }

    .mpStep {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .mpStep_box {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .mpStep_mess {
                display: flex;
                flex-direction: column;
                align-items: center;

                .mpStep_boxicon {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    background: #fff;
                    text-align: center;
                    line-height: 80px;
                    font-size: 44px;
                    color: #c0c4cc;
                    margin-bottom: 15px;
                }

                p {
                    color: #fff;
                    font-size: 14px;
                }
            }

            img {
                margin-top: -20px;
            }
        }

        /deep/ .el-step.is-center .el-step__line {
            left: 90%;
            right: -10%;
        }

        /deep/ .el-step__title.is-wait {
            color: #fff;
            font-size: 14px;
        }

        /deep/ .el-step__line {
            border-bottom: 2px dotted #fff;
            background-color: transparent;
            top: 45px !important;
        }

        /deep/ .el-step__icon.is-icon {
            width: 80px;
            height: 80px;
            border-radius: 50%;
        }

        /deep/ .el-step__icon-inner {
            font-size: 44px;
        }
    }

    .printTitle {
        font-weight: bold;
        color: #1f7de9;
        padding-top: 60px;
        margin-bottom: 15px;

        span.more {
            font-weight: normal;
            cursor: pointer;
            font-size: 12px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
            cursor: pointer;
        }
    }

    .box-card {
        margin-bottom: 30px;
        position: relative;
        // cursor: pointer;
		/deep/.el-card__body{
			padding: 20px 15px 15px 15px;
		}

        .image {
            width: 100%;
            height: 200px;
            display: block;
            overflow: hidden;
            cursor: pointer;
            img {
                width: 100%;
                height: 200px;
                transition: all 1s;
            }
        }
    }

    .box-card:hover {
        .image {
            img {
                transform: scale(1.2);
            }
        }
    }

    .mpBox {
        display: flex;
    }

    .tagsbox {
        span:nth-of-type(2) {
            color: #409eff;
            background-color: #ecf5ff;
            border-color: #d9ecff;
            margin-left: 10px;
        }
    }
    .titname:hover .mpTitle{
            cursor: pointer;
            color: #157efb ;
    }
    .mpCheck {
        position: absolute;
        right: 20px;
        top: 20px;
    }

    .mpTitle {
        font-size: 16px;
        font-weight: normal;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mpComp {
        margin-top: 10px;
        font-size: 13px;
        color: #000000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mpPrice {
        margin: 10px 0;
        font-size: 13px;
        color: #da251d;

        span {
            color: #000;
            margin-left: 10px;
        }
    }

    .mpDetail {
        margin-top: 10px;

        dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: normal;
            line-height: 22px !important;
        }

        dd {
            font-size: 13px;
            line-height: 22px !important;
            margin-left: 70px;
            margin-bottom: 6px;
            color: #808080;
        }
    }

    .mpFooter-v1 {
        text-align: center;
        font-size: 14px;
        background: #fff;
        border: 1px solid #ebeef5;
        margin: -10px -21px -21px;
        height: 50px;
        line-height: 50px;
    }

    .mpFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        border-top: 1px solid #e3e3e3;
        margin: 0 0 -15px;
        position: relative;

        span {
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            line-height: 50px;
        }

        span a {
            font-size: 12px;
            color: #808080;
        }

        span a:hover {
            color: rgba(21, 126, 251, 0.8);
        }

        :after {
            position: absolute;
            content: "";
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
        }
    }

    .printBox {
        /deep/ .el-input--suffix .el-input__inner {
            padding: 0 15px;
        }
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both;
    }

    a {
        color: #157efb;
    }

    a:hover {
        color: rgba(21, 126, 251, 0.8);
    }

    .backImage {
        // background: url("../../assets/我要打印/我要打印-banner.jpg") no-repeat;
        // background: no-repeat;
        // background-size: 100%;
        position: relative;

        .backBannerimgs {
            width: 100%;
            display: block;
            height: 500px;
        }
    }

    .materArt {
        border-bottom: 1px solid #efefef;
        padding: 20px 0 10px 20px;
        font-size: 14px;

        .materiaTitle {
            /*margin-right: 15px;*/
        }

        .materArtallP1 {
            margin-right: 15px;
            cursor: pointer;
        }

        .materArtallP {
            /*margin-right: 15px;*/
            cursor: pointer;
            color: #157efb;
        }

        .materArtallP span {
            cursor: pointer;
            background: #157efb;
            border-radius: 5px;
            margin-bottom: 10px;
            color: #fff;
            padding: 3px 15px;
            font-size: 14px;
            white-space: nowrap;
            margin-right: 15px;
        }
    }

    .materArtall {
        font-size: 14px;
        // border-bottom: 1px solid #efefef;
        padding: 5px 0 5px 20px;

        .materiaTitle {
            /*margin-right: 15px;*/
        }

        .materArtallP1 {
            margin-right: 15px;
            cursor: pointer;
        }

        .materArtallP span {
            cursor: pointer;
            margin-right: 15px;
            background: #157efb;
            border-radius: 5px;
            margin-bottom: 10px;
            color: #fff;
            padding: 3px 15px;
            font-size: 14px;
        }
    }

    .screenArtall {
        font-size: 14px;
        padding: 10px 0 10px 20px;

        .materArtallP1 span {
            margin-right: 15px;
            cursor: pointer;

            background: #fff;
            color: #157efb;
            border: 1px solid #efefef;
            border-radius: 2px;
            margin-bottom: 10px;
            padding: 3px 15px;
            padding-right: 10px;
            font-size: 14px;

            i {
                margin-left: 5px;
            }
        }

        .materArtallP span {
            cursor: pointer;
            margin-right: 15px;
            background: #157efb;
            border-radius: 2px;
            margin-bottom: 10px;
            color: #fff;
            padding: 3px 15px;
            padding-right: 10px;
            font-size: 14px;
            margin-right: 15px;

            i {
                margin-left: 5px;
            }
        }
    }

    .materDetails {
        flex-wrap: wrap;
        margin-left: 60px;
        padding: 0 0 0 20px;
        font-size: 14px;
        margin-top: 10px;

        p {
            margin-right: 10px;
            cursor: pointer;
            padding: 0 5px;
            font-size: 13px;
        }

        .materDetailsT span {
            /*background: #d9e7f7;*/
            /*border-radius: 5px;*/
            margin-bottom: 10px;
            color: #157efb;
            /*padding:3px 15px;*/
            font-size: 14px;
        }
    }

    .img_div {
        display: block;
        position: relative;
    }

    .imageEl {
        width: 100%;
        height: 80px;
        display: block;
        cursor: pointer;
        box-shadow: 0px 0px 5px 2px #efefef;
        background: rgba(0, 0, 0, 0.221);
    }

    .mask {
        position: absolute;
        background: rgba(101, 101, 101, 0.6);
        color: #ffffff;
        opacity: 0;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        pointer-events: none;

        .maskContent {
            position: absolute;
            top: 50%;
            width: 100%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
        }

        p {
            text-align: center;
        }
    }

    .img_div:hover .mask {
        opacity: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/print/index.vue